import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import "./categoryCard.css";
import ICategory from "../../interfaces/ICategory";
import { useNavigate } from "react-router-dom";

const CategoryCard = ({ category }: { category: ICategory }) => {
  const navigate = useNavigate();
  const nav = (evt: React.MouseEvent, url: string) => {
    evt.preventDefault();
    navigate(url);
  };

  return (
    <Card className="landing-page-cards" onClick={(evt:React.MouseEvent) => { }}>
      <Card.Img
        className="cat-card-img"
        title={category.name}
        src={category.imageUrl}
      />
      <Link to={`/category/${category.categoryTagId}`}>
        <Card.Title className="card-titles">{category.displayName}</Card.Title>
      </Link>
      <Card.Body className="card-link-text">
        {category.children.length > 0 &&
          category.children.map((sub: ICategory, index: number) => {
            return (
              <Card.Link
                className="card-link-text"
                href={`/category/${sub.categoryTagId}`}
                key={index}
                onClick={(evt:React.MouseEvent) => {     
                  window.localStorage.setItem("currentCategoryID", category.categoryTagId);      
                  window.localStorage.setItem("subCurrentCategoryID", sub.categoryTagId);  
                  window.localStorage.setItem("thirdCurrentCategoryID", "");            
                  nav(evt,`/category/${sub.categoryTagId}`);                            
              }}
              >
                {sub.displayName}
              </Card.Link>
            );
          })}
      </Card.Body>
    </Card>
  );
};

export default CategoryCard;
